export default {
  models: [
    "XIP712",
    "XIP813",
    "ZIP1018",
    "HEVC211",
    "XIP913",
    "ZIP110",
    "XIP913RC",
    "XIP112",
    "XIP110",
    "XIP110RC",
    "ATVMJ4",
    "ATVWJ4",
    "SNAP2",
  ],
  internet: ["ethernet", "wireless"],
  environment: ["beta", "development", "production"],
  swid: [],
  timezone: [
    "Central Daylight Time GMT-5",
    "Mountain Daylight Time GMT-6",
    "Mountain Standard Time GMT-7",
    "Pacific Daylight Time GMT-7",
    "Alaska Daylight Time GMT-8",
    "Hawaii Standard Time GMT-10",
  ],
  state: ["live_tv", "full_standby", "partial_standby"],
  tooltipStr: `? – matches if zero or one occurrence of any of the patterns in the pattern-list match
  * - matches if zero or more occurrences of any of the patterns in the pattern-list match
  + - matches if one or more occurrences of any of the patterns in the pattern-list match
  @ - matches if exactly one occurrence of any of the patterns in the pattern-list match
  ! - matches if the input string cannot be matched with of the patterns in the pattern-list match`,
  dma: [
    { valueDMA: 662, nameDMA: "Abliene-Sweetwater", ST: "TX" },
    { valueDMA: 991, nameDMA: "AK non-dma", ST: "AK" },
    { valueDMA: 525, nameDMA: "Albany", ST: "GA" },
    { valueDMA: 532, nameDMA: "Albany-Schenectady-Troy", ST: "NY" },
    { valueDMA: 790, nameDMA: "Albuquerque-Santa Fe", ST: "NM" },
    { valueDMA: 644, nameDMA: "Alexandria", ST: "LA" },
    { valueDMA: 583, nameDMA: "Alpena", ST: "MI" },
    { valueDMA: 634, nameDMA: "Amarillo", ST: "TX" },
    { valueDMA: 743, nameDMA: "Anchorage", ST: "AK" },
    { valueDMA: 524, nameDMA: "Atlanta", ST: "GA" },
    { valueDMA: 520, nameDMA: "Augusta-Aiken", ST: "GA" },
    { valueDMA: 635, nameDMA: "Austin", ST: "TX" },
    { valueDMA: 800, nameDMA: "Bakersfield", ST: "CA" },
    { valueDMA: 512, nameDMA: "Baltimore", ST: "MD" },
    { valueDMA: 537, nameDMA: "Bangor", ST: "ME" },
    { valueDMA: 716, nameDMA: "Baton Rouge", ST: "LA" },
    { valueDMA: 692, nameDMA: "Beaumont-Port Arthur", ST: "TX" },
    { valueDMA: 821, nameDMA: "Bend", ST: "OR" },
    { valueDMA: 756, nameDMA: "Billings", ST: "MT" },
    { valueDMA: 746, nameDMA: "Biloxi-Gulfport", ST: "MS" },
    { valueDMA: 502, nameDMA: "Binghamton", ST: "NY" },
    { valueDMA: 630, nameDMA: "Birmingham", ST: "AL" },
    { valueDMA: 559, nameDMA: "Bluefield-Beckley-Oak Hill", ST: "WV" },
    { valueDMA: 757, nameDMA: "Boise", ST: "ID" },
    { valueDMA: 506, nameDMA: "Boston (Manchester)", ST: "MA" },
    { valueDMA: 736, nameDMA: "Bowling Green", ST: "KY" },
    { valueDMA: 514, nameDMA: "Buffalo", ST: "NY" },
    { valueDMA: 523, nameDMA: "Burlington-Plattsburgh", ST: "VT" },
    { valueDMA: 754, nameDMA: "Butte-Bozeman", ST: "MT" },
    { valueDMA: 767, nameDMA: "Casper-Riverton", ST: "WY" },
    { valueDMA: 637, nameDMA: "Cedar Rapids-Waterloo-Dublin", ST: "IA" },
    { valueDMA: 648, nameDMA: "Champaign-Springfield-Decatur", ST: "IL" },
    { valueDMA: 519, nameDMA: "Charleston", ST: "SC" },
    { valueDMA: 564, nameDMA: "Charleston-Huntingon", ST: "WV" },
    { valueDMA: 517, nameDMA: "Charlotte", ST: "NC" },
    { valueDMA: 584, nameDMA: "Charlottesville", ST: "VA" },
    { valueDMA: 575, nameDMA: "Chattanooga", ST: "TN" },
    { valueDMA: 759, nameDMA: "Cheyenne-Scottsbluff", ST: "WY" },
    { valueDMA: 602, nameDMA: "Chicago", ST: "IL" },
    { valueDMA: 868, nameDMA: "Chico-Redding", ST: "CA" },
    { valueDMA: 515, nameDMA: "Cincinnati", ST: "OH" },
    { valueDMA: 598, nameDMA: "Clarksburg-Weston", ST: "WV" },
    { valueDMA: 510, nameDMA: "Cleveland-Akron", ST: "OH" },
    { valueDMA: 752, nameDMA: "Colorado Springs-Pueblo", ST: "CO" },
    { valueDMA: 546, nameDMA: "Columbia", ST: "SC" },
    { valueDMA: 604, nameDMA: "Columbia-Jefferson City", ST: "MO" },
    { valueDMA: 522, nameDMA: "Columbus - Opelika", ST: "GA" },
    { valueDMA: 535, nameDMA: "Columbus", ST: "OH" },
    { valueDMA: 673, nameDMA: "Columbus-Tupelo", ST: "MS" },
    { valueDMA: 600, nameDMA: "Corpus Christi", ST: "TX" },
    { valueDMA: 623, nameDMA: "Dallas-Ft. Worth", ST: "TX" },
    { valueDMA: 682, nameDMA: "Davenport-R. Island-Moline", ST: "IA" },
    { valueDMA: 542, nameDMA: "Dayton", ST: "OH" },
    { valueDMA: 751, nameDMA: "Denver", ST: "CO" },
    { valueDMA: 679, nameDMA: "Des Moines-Ames", ST: "IA" },
    { valueDMA: 505, nameDMA: "Detroit", ST: "MI" },
    { valueDMA: 606, nameDMA: "Dothan", ST: "AL" },
    { valueDMA: 676, nameDMA: "Duluth-Superior", ST: "MN" },
    { valueDMA: 765, nameDMA: "El Paso", ST: "TX" },
    { valueDMA: 565, nameDMA: "Elmira-Corning", ST: "NY" },
    { valueDMA: 516, nameDMA: "Erie", ST: "PA" },
    { valueDMA: 801, nameDMA: "Eugene", ST: "OR" },
    { valueDMA: 802, nameDMA: "Eureka", ST: "CA" },
    { valueDMA: 649, nameDMA: "Evansville", ST: "IN" },
    { valueDMA: 745, nameDMA: "Fairbanks", ST: "AK" },
    { valueDMA: 724, nameDMA: "Fargo-Valley City", ST: "ND" },
    { valueDMA: 513, nameDMA: "Flint-Saginaw-Bay City", ST: "MI" },
    { valueDMA: 866, nameDMA: "Fresno-Visalia", ST: "CA" },
    { valueDMA: 571, nameDMA: "Ft. Myers-Naples", ST: "FL" },
    {
      valueDMA: 670,
      nameDMA: "Ft. Smith-Fayetteville-Springfield-Rogers",
      ST: "AR",
    },
    { valueDMA: 509, nameDMA: "Ft. Wayne", ST: "IN" },
    { valueDMA: 592, nameDMA: "Gainesville", ST: "FL" },
    { valueDMA: 798, nameDMA: "Glendive", ST: "MT" },
    { valueDMA: 773, nameDMA: "Grand Junction-Montrose", ST: "CO" },
    { valueDMA: 563, nameDMA: "Grand Rapids-Kalamazoo", ST: "MI" },
    { valueDMA: 755, nameDMA: "Great Falls", ST: "MT" },
    { valueDMA: 658, nameDMA: "Green Bay-Appleton", ST: "WI" },
    { valueDMA: 518, nameDMA: "Greensboro-High Point", ST: "NC" },
    { valueDMA: 545, nameDMA: "Greenville-New Bern-Washington", ST: "NC" },
    { valueDMA: 567, nameDMA: "Greenville-Spartanburg-Asheville", ST: "SC" },
    { valueDMA: 647, nameDMA: "Greenwood-Greenville", ST: "MS" },
    { valueDMA: 636, nameDMA: "Harlingen-McAllen", ST: "TX" },
    { valueDMA: 566, nameDMA: "Harrisburg-Lancaster-Lebanon-York", ST: "PA" },
    { valueDMA: 569, nameDMA: "Harrisonburg", ST: "VA" },
    { valueDMA: 533, nameDMA: "Hartford-New Haven", ST: "CT" },
    { valueDMA: 710, nameDMA: "Hattiesburg-Laurel", ST: "MS" },
    { valueDMA: 766, nameDMA: "Helena", ST: "MT" },
    { valueDMA: 744, nameDMA: "Honolulu", ST: "HI" },
    { valueDMA: 618, nameDMA: "Houston", ST: "TX" },
    { valueDMA: 691, nameDMA: "Huntsville-Decatur", ST: "AL" },
    { valueDMA: 758, nameDMA: "Idaho Falls-Pocatello", ST: "ID" },
    { valueDMA: 527, nameDMA: "Indianapolis", ST: "IN" },
    { valueDMA: 639, nameDMA: "Jackson", ST: "TN" },
    { valueDMA: 718, nameDMA: "Jackson", ST: "MS" },
    { valueDMA: 561, nameDMA: "Jacksonville", ST: "FL" },
    { valueDMA: 574, nameDMA: "Johnstown-Altoona", ST: "PA" },
    { valueDMA: 734, nameDMA: "Jonesboro", ST: "AR" },
    { valueDMA: 603, nameDMA: "Joplin-Pittsburg", ST: "MO" },
    { valueDMA: 747, nameDMA: "Juneau", ST: "AK" },
    { valueDMA: 616, nameDMA: "Kansas City", ST: "MO" },
    { valueDMA: 557, nameDMA: "Knoxville", ST: "TN" },
    { valueDMA: 702, nameDMA: "La Crosse-Eau Claire", ST: "WI" },
    { valueDMA: 582, nameDMA: "Lafayette", ST: "IN" },
    { valueDMA: 642, nameDMA: "Lafayette", ST: "LA" },
    { valueDMA: 643, nameDMA: "Lake Charles", ST: "LA" },
    { valueDMA: 551, nameDMA: "Lansing", ST: "MI" },
    { valueDMA: 749, nameDMA: "Laredo", ST: "TX" },
    { valueDMA: 839, nameDMA: "Las Vegas", ST: "NV" },
    { valueDMA: 541, nameDMA: "Lexington", ST: "KY" },
    { valueDMA: 558, nameDMA: "Lima", ST: "OH" },
    { valueDMA: 722, nameDMA: "Lincoln-Hastings", ST: "NE" },
    { valueDMA: 693, nameDMA: "Little Rock-Pine Bluff", ST: "AR" },
    { valueDMA: 803, nameDMA: "Los Angeles", ST: "CA" },
    { valueDMA: 529, nameDMA: "Louisville", ST: "KY" },
    { valueDMA: 651, nameDMA: "Lubbock", ST: "TX" },
    { valueDMA: 503, nameDMA: "Macon", ST: "GA" },
    { valueDMA: 669, nameDMA: "Madison", ST: "WI" },
    { valueDMA: 737, nameDMA: "Mankato", ST: "MN" },
    { valueDMA: 553, nameDMA: "Marquette", ST: "MI" },
    { valueDMA: 813, nameDMA: "Medford-Klamath Falls", ST: "OR" },
    { valueDMA: 640, nameDMA: "Memphis", ST: "TN" },
    { valueDMA: 711, nameDMA: "Meridian", ST: "MS" },
    { valueDMA: 528, nameDMA: "Miami-Ft. Lauderdale", ST: "FL" },
    { valueDMA: 617, nameDMA: "Milwaukee", ST: "WI" },
    { valueDMA: 613, nameDMA: "Minneapolis-St. Paul", ST: "MN" },
    { valueDMA: 687, nameDMA: "Minot-Bismarck", ST: "ND" },
    { valueDMA: 762, nameDMA: "Missoula", ST: "MT" },
    { valueDMA: 686, nameDMA: "Mobile-Pensacola-Ft. Walton", ST: "AL" },
    { valueDMA: 628, nameDMA: "Monroe-El Dorado", ST: "LA" },
    { valueDMA: 828, nameDMA: "Monterey-Salinas", ST: "CA" },
    { valueDMA: 698, nameDMA: "Montgomery-Selma", ST: "AL" },
    { valueDMA: 570, nameDMA: "Myrtle Beach-Florence", ST: "SC" },
    { valueDMA: 659, nameDMA: "Nashville", ST: "TN" },
    { valueDMA: 622, nameDMA: "New Orleans", ST: "LA" },
    { valueDMA: 501, nameDMA: "New York", ST: "NY" },
    { valueDMA: 544, nameDMA: "Norfolk-Portsmouth-Newport News", ST: "VA" },
    { valueDMA: 740, nameDMA: "North Platte", ST: "NE" },
    { valueDMA: 633, nameDMA: "Odessa-Midland", ST: "TX" },
    { valueDMA: 650, nameDMA: "Oklahoma City", ST: "OK" },
    { valueDMA: 652, nameDMA: "Omaha", ST: "NE" },
    { valueDMA: 534, nameDMA: "Orlando-Daytona Beach", ST: "FL" },
    { valueDMA: 631, nameDMA: "Ottumwa-Kirksville", ST: "MO" },
    { valueDMA: 632, nameDMA: "Paducah-Cape Girard", ST: "KY" },
    { valueDMA: 804, nameDMA: "Palm Springs", ST: "CA" },
    { valueDMA: 656, nameDMA: "Panama City", ST: "FL" },
    { valueDMA: 597, nameDMA: "Parkersburg", ST: "WV" },
    { valueDMA: 675, nameDMA: "Peoria-Bloomington", ST: "IL" },
    { valueDMA: 504, nameDMA: "Philadelphia", ST: "PA" },
    { valueDMA: 753, nameDMA: "Phoenix", ST: "AZ" },
    { valueDMA: 508, nameDMA: "Pittsburgh", ST: "PA" },
    { valueDMA: 500, nameDMA: "Portland-Auburn", ST: "ME" },
    { valueDMA: 820, nameDMA: "Portland", ST: "OR" },
    { valueDMA: 552, nameDMA: "Presque Isle", ST: "ME" },
    { valueDMA: 521, nameDMA: "Providence-New Bedford", ST: "RI" },
    { valueDMA: 995, nameDMA: "Puerto Rico", ST: "PR" },
    { valueDMA: 717, nameDMA: "Quincy-Hannibal-Keokuk", ST: "IL" },
    { valueDMA: 560, nameDMA: "Raleigh-Durham", ST: "NC" },
    { valueDMA: 764, nameDMA: "Rapid City", ST: "SD" },
    { valueDMA: 811, nameDMA: "Reno", ST: "NV" },
    { valueDMA: 556, nameDMA: "Richmond-Petersburg", ST: "VA" },
    { valueDMA: 573, nameDMA: "Roanoke-Lynchburg", ST: "VA" },
    { valueDMA: 538, nameDMA: "Rochester", ST: "NY" },
    { valueDMA: 611, nameDMA: "Rochester-Mason City-Austin", ST: "MN" },
    { valueDMA: 610, nameDMA: "Rockford", ST: "IL" },
    { valueDMA: 862, nameDMA: "Sacramento-Stockton-Modesto", ST: "CA" },
    { valueDMA: 576, nameDMA: "Salisbury", ST: "MD" },
    { valueDMA: 770, nameDMA: "Salt Lake City", ST: "UT" },
    { valueDMA: 661, nameDMA: "San Angelo", ST: "TX" },
    { valueDMA: 641, nameDMA: "San Antonio", ST: "TX" },
    { valueDMA: 825, nameDMA: "San Diego", ST: "CA" },
    { valueDMA: 807, nameDMA: "San Francisco-Oakland-San Jose", ST: "CA" },
    { valueDMA: 855, nameDMA: "Santa Barbara-San Luis Obispo", ST: "CA" },
    { valueDMA: 507, nameDMA: "Savannah", ST: "GA" },
    { valueDMA: 819, nameDMA: "Seattle-Tacoma", ST: "WA" },
    { valueDMA: 657, nameDMA: "Sherman-Ada", ST: "TX" },
    { valueDMA: 612, nameDMA: "Shreveport", ST: "LA" },
    { valueDMA: 624, nameDMA: "Sioux City", ST: "IA" },
    { valueDMA: 725, nameDMA: "Sioux Falls", ST: "SD" },
    { valueDMA: 588, nameDMA: "South Bend-Elkhart", ST: "IN" },
    { valueDMA: 881, nameDMA: "Spokane", ST: "WA" },
    { valueDMA: 543, nameDMA: "Springfield-Holyoke", ST: "MA" },
    { valueDMA: 619, nameDMA: "Springfield", ST: "MO" },
    { valueDMA: 638, nameDMA: "St. Joseph", ST: "MO" },
    { valueDMA: 609, nameDMA: "St. Louis", ST: "MO" },
    { valueDMA: 555, nameDMA: "Syracuse", ST: "NY" },
    { valueDMA: 530, nameDMA: "Tallahassee-Thomasville", ST: "FL" },
    { valueDMA: 539, nameDMA: "Tampa-St. Petersburg", ST: "FL" },
    { valueDMA: 581, nameDMA: "Terre Haute", ST: "IN " },
    { valueDMA: 547, nameDMA: "Toledo", ST: "OH" },
    { valueDMA: 605, nameDMA: "Topeka", ST: "KS" },
    { valueDMA: 540, nameDMA: "Traverse City-Cadillac", ST: "MI" },
    { valueDMA: 531, nameDMA: "Tri-Cities (TN-VA)", ST: "TN" },
    { valueDMA: 789, nameDMA: "Tucson", ST: "AZ" },
    { valueDMA: 671, nameDMA: "Tulsa", ST: "OK" },
    { valueDMA: 760, nameDMA: "Twin Falls", ST: "ID" },
    { valueDMA: 709, nameDMA: "Tyler-Longview", ST: "TX" },
    { valueDMA: 526, nameDMA: "Utica", ST: "NY" },
    { valueDMA: 626, nameDMA: "Victoria", ST: "TX" },
    { valueDMA: 625, nameDMA: "Waco-Temple-Bryan", ST: "TX" },
    { valueDMA: 511, nameDMA: "Washington", ST: "DC" },
    { valueDMA: 549, nameDMA: "Watertown", ST: "NY" },
    { valueDMA: 705, nameDMA: "Wausau-Rhinelander", ST: "WI" },
    { valueDMA: 548, nameDMA: "West Palm Beach-Ft. Pierce", ST: "FL" },
    { valueDMA: 554, nameDMA: "Wheeling-Steubenville", ST: "WV" },
    { valueDMA: 678, nameDMA: "Wichita-Hutchinson", ST: "KS" },
    { valueDMA: 627, nameDMA: "Wichita Falls-Lawton", ST: "TX" },
    { valueDMA: 577, nameDMA: "Wilkes Barre-Scranton", ST: "PA" },
    { valueDMA: 550, nameDMA: "Wilmington", ST: "NC" },
    { valueDMA: 810, nameDMA: "Yakima-Pasco-Richland-Kennewick", ST: "WA" },
    { valueDMA: 536, nameDMA: "Youngstown", ST: "OH" },
    { valueDMA: 771, nameDMA: "Yuma-El Centro", ST: "AZ" },
    { valueDMA: 596, nameDMA: "Zanesville", ST: "OH" },
  ],
};
